// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SuccessOverlay_overlay_9KLO0","img":"SuccessOverlay_img_1yiBj","count-down":"SuccessOverlay_count-down_NF_0X"};